import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TokenListComponent} from './token-list.component';
import {routing} from './token-list.routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {TokenListService} from './token-list.service';
import {TbillBillServiceService} from '../billing/tbill-bill-service/tbill-bill-service.service';
import {ChangeLanguageModule} from '../shared/change-language/change-language.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {NgxPaginationModule} from 'ngx-pagination';
import {LayoutModule} from '../layout/layout.module';
import {TrnServiceCabinScheduleService} from '../configuration/trn-service-cabin-schedule/trn-service-cabin-schedule.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {AutoCompleteModule, MultiSelectModule} from 'primeng/primeng';
import {MstDepartmentService} from '../configuration/mst-department/mst-department.service';
import {MstSubDepartmentService} from '../configuration/mst-sub-department/mst-sub-department.service';
import {MstCabinService} from '../configuration/mst-cabin/mst-cabin.service';
import {MstStaffService} from '../configuration/mst-staff/mst-staff.service';
import {MstSpecialityService} from '../configuration/mst-speciality/mst-speciality.service';
import { IpdTokenListComponent } from './ipd-token-list/ipd-token-list.component';
import {TrnAdmissionService} from '../configuration/trn-admission/trn-admission.service';

@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        HttpModule,
        ReactiveFormsModule, SharedTranslationModule, ChangeLanguageModule,
        NgxPaginationModule, LayoutModule,
        AutoCompleteModule, MultiSelectModule
    ],
    declarations: [TokenListComponent, IpdTokenListComponent],
    providers: [TokenListService,TrnAdmissionService,
        TbillBillServiceService, TrnServiceCabinScheduleService, MstUnitService, MstDepartmentService, MstSubDepartmentService, MstCabinService, MstStaffService, MstSpecialityService]
})
export class TokenListModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-list/token-list.module.ts